// extracted by mini-css-extract-plugin
module.exports = {"styledInput":"Kx9Glm5M","buttonWrapper":"BFRR7Tv0"};